<script setup>
import { useI18n } from "vue-i18n";
import WordpressSection from "./Settings/WordpressSection.vue";
import SEOSection from "./Settings/SEOSection.vue";

const props = defineProps(["modelValue", "templates", "statuses", "categories", "users", "postTypes"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <Teleport to="#content-sidebar-root">
        <div class="w-[20rem] isolate relative lg:w-[26rem]">
            <div class="overflow-hidden">
                <div class="border-white/5 w-[20rem] h-screen fixed top-0 right-0 bottom-0 bg-gray-900 border-l lg:w-[26rem]">
                    <div class="h-screen overflow-y-auto space-y-2">
                        <WordpressSection
                            :modelValue="modelValue"
                            @update:modelValue="$emit('update:modelValue', $event)"
                            :templates="templates"
                            :statuses="statuses"
                            :categories="categories"
                            :postTypes="postTypes"
                            :users="users" />
                        <SEOSection :modelValue="modelValue" @update:modelValue="$emit('update:modelValue', $event)" />
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
